// extracted by mini-css-extract-plugin
export var focusRing = "button-module--focusRing--19cc3";